import type { GroupInfosResponse } from './types';

import { apiClient } from '~shared/api';

export const getGroupInfos = (group: string): Promise<GroupInfosResponse> =>
  apiClient.get<GroupInfosResponse>(`/api/${group}/infos`, { groupId: group });
